<template>
  <li
    class="nav-bar-item"
    :key="item._uid"
    ref="refRoot"
  >
    <Cta
      :blok="item"
      :hovering="hovering"
    >
      <HoverReveal :hovering="hovering">
        <span class="label">{{ item.label }}</span>
      </HoverReveal>
    </Cta>
  </li>
</template>

<script setup lang="ts">
const props = defineProps({
  item: {
    required: true,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const hovering = useElementHover(refRoot)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.nav-bar-item {
  height: 100%;

  .cta {
    display: block;
    height: 100%;
    @include flex(row, center, center);
    padding-inline: $p3 / 2;
  }

  :deep(.reveal-content) {
    @include gradientText();
  }
}
</style>
